module.exports = __webpack_public_path__ + "img/noData.5fc19235.png";